import { observer } from "mobx-react-lite";
import { canvasImageStore } from "../../stores/ImageStore";

const UploadResponseModal = observer(({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg shadow-lg">
        <h2 className="text-xl font-semibold mb-4">Upload Summary</h2>
        <div className="mb-4">
          <p>Total Files: {canvasImageStore.totalFilesCount}</p>
          <p>Successfully Uploaded: {canvasImageStore.successCount}</p>
          <p>Failed Uploads: {canvasImageStore.errorCount}</p>
        </div>

        {canvasImageStore.errorFiles.length > 0 && (
          <div className="mb-4">
            <h3 className="font-semibold mb-2">Failed files:</h3>
            <ul className="list-disc list-inside">
              {canvasImageStore.errorFiles.map((file, index) => (
                <li key={index} className="text-red-600">
                  {file.fileName}: {file.errorMsg}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
});

export default UploadResponseModal;
export {};
